import { useReactiveVar } from '@apollo/client';

import { Role } from '@/routes/PrivateRoute';
import {
  CurrentCustomerAdminFragment,
  CurrentTenantAdminFragment,
} from '@/types/graphql';
import { currentAdminVar, currentAgencyVar } from '@/util/apollo/cache';

const useAuth = () => {
  const currentAgency = useReactiveVar(currentAgencyVar);

  // Adding this typeguard to ensure if customer is a property of currentAdmin object.
  const isCurrentCustomerAdmin = (
    arg: CurrentCustomerAdminFragment | CurrentTenantAdminFragment | null,
  ): arg is CurrentCustomerAdminFragment =>
    (arg as CurrentCustomerAdminFragment).customer !== undefined;

  const currentAdmin = useReactiveVar(currentAdminVar);
  const currentAdminIsCustomerAdmin =
    currentAdmin?.role === Role.CUSTOMER_ADMIN;
  // Strict tenant-admin check (helpdesk admins excluded too) — gates
  // GravyWork-internal cost signals like the OT risk banner and the
  // "Hours This Week" staffing column.
  const currentAdminIsTenantAdmin = currentAdmin?.role === Role.TENANT_ADMIN;

  return {
    currentAdmin,
    currentAdminIsCustomerAdmin,
    currentAdminIsTenantAdmin,
    isCurrentCustomerAdmin,
    currentAgency,
  };
};

export default useAuth;
